<template>
  <!-- ふきだし -->
  <v-container class="pa-0">
    <div class="line-bc">
      <div class="balloon6">
        <div class="faceicon">
          <img :src="iconUrl" />
        </div>
        <div class="chatting">
          <div class="says-border" v-if="!errorContent">
            <span class="pre-wrap" v-text="content1" />
            <span class="text-h4">{{ waitTime }} 分</span>
            <span class="pre-wrap" v-text="content2" />
          </div>
          <div class="says-border" v-else>
            <span class="pre-wrap" v-text="errorContent" />
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    waitTime: Number,
    errorContent: String,
    // question: String,
    // content: String,
    // borderContent: { type: Boolean, default: true },
  },

  data: () => ({
    // ふきだし(左側)
    // styleContent: "says-border",

    content1: "メニューはこちらです。\nただいまのできあがり時間は、\n",
    content2: "\nくらいです。",
  }),
  created() {},
  async mounted() {},
  computed: {
    ...mapGetters(["iconUrl"]),
  },
  methods: {},
};
</script>

<style>
@import "../../css/common.css";
@import "../../css/bubble.css";
</style>
